<ng-form>
  <div class="row mail-editor">
    <div class="col-12 col-md">
      <!-- SUBJECT -->
      <div class="form-group">
        <label for="subject">
          <span translate>Subject</span>
        </label>
        <input type="text"
          [(ngModel)]="template.subject"
          #subject="ngModel"
          name="subject" id="subject"
          class="form-control"
          required="required"
          (ngModelChange)="onValueChange()"
          (focus)="onFocusControl($event)"
          [disabled]="!isAdminRole && !isSuperAdminRole"
          [ngClass]="{ 'is-invalid':  subject.errors }">

          @if (subject.invalid) {
            <div class="invalid-feedback">
              @if (subject?.errors?.required) {
                <span><span translate>Email subject required</span></span>
              }
            </div>
          }
        </div>

        <!--  MESSAGE-->
        <div class="form-group">
          <label for="message">
            <span translate>Message</span>
          </label>

          <textarea type="text" name="message" id="message" class="form-control"
            [(ngModel)]="template.message"
            #message="ngModel"
            required="required"
            [ngStyle]="{'height': template.height+'px'}"
            (focus)="onFocusControl($event)"
            (mouseup)="onMessageAreaResize($event)"
            (ngModelChange)="onValueChange()"
            [disabled]="!isAdminRole && !isSuperAdminRole"
          [ngClass]="{ 'is-invalid':  message.errors }"></textarea>

          @if (message.errors) {
            <div class="invalid-feedback">
              @if (message?.errors?.required) {
                <span><span translate>Email message required</span></span>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-12 col-md-auto mail-editor-placeholders pr-5">
        <label class="d-block" translate>Placeholders</label>
        @for (placeholder of placeholders; track placeholder) {
          <button
            (click)="onAddPlaceholder(placeholder)"
            [disabled]="!isSuperAdminRole && !isAdminRole"
            class="btn btn-outline-primary d-inline-block mr-2 mr-md-0 d-md-block btn-sm mb-2">
            <span class="fa-solid fa-circle-plus"></span>
            <span [innerText]="placeholder"></span>
          </button>
        }
      </div>
    </div>
  </ng-form>
